<template>
  <q-dialog v-model="dialogUploadBonusAffiliate">
    <q-card style="min-width: 700px">
      <q-form @submit="onSave">
        <q-toolbar class="bg-primary text-white">
          <q-toolbar-title> {{ $t("batch_bonus_upload") }} </q-toolbar-title>
          <q-btn flat round dense icon="mdi-close" @click="onClose" />
        </q-toolbar>

        <q-dialog v-model="showModal" persistent>
          <q-card style="width: 600px; max-width: 80vw">
            <q-toolbar class="bg-primary text-white">
              <q-toolbar-title> {{ $t("bonus_upload_file_format") }} </q-toolbar-title>
              <q-btn flat round dense icon="mdi-close" @click="showModal = false" />
            </q-toolbar>
            <q-card-section class="row q-col-gutter-md">
              <div class="col-12">
                <div class="text-body q-mb-md">
                  {{ $t("bonus_file_instructions") }} <b>{{ $t("columns") }}:</b>
                </div>
                <div><b>{{ $t("campaign_id") }}</b></div>
                <div><b>{{ $t("channel_id") }}</b></div>
                <div><b>{{ $t("cost") }}</b> {{ $t("decimal_separator") }}</div>
                <div><b>{{ $t("margin") }}</b> {{ $t("decimal_separator") }}</div>
                <div><b>{{ $t("bonus_date") }}</b> {{ $t("date_format_instruction") }}</div>
                <div><b>{{ $t("bonus_type") }}</b></div>
                <ul>
                  <li>1 - {{ $t("order_price") }}</li>
                  <li>2 - 10,19%</li>
                  <li>3 - {{ $t("preference") }}</li>
                  <li>4 - {{ $t("exclusivity") }}</li>
                  <li>5 - {{ $t("black_friday") }}</li>
                  <li>6 - {{ $t("compensation") }}</li>
                  <li>7 - {{ $t("others") }}</li>
                  <li>8 - {{ $t("bet_transactions") }}</li>
                </ul>

                <div><b>{{ $t("reference_2") }}</b> ({{ $t('free_field') }})</div>
              </div>
            </q-card-section>
            <q-card-actions>
              <p class="text-red-5">
                <b>{{ $t("attention") }}</b> {{ $t('bonus_upload_warning') }}
              </p>
            </q-card-actions>
            <q-card-actions align="right">
              <q-btn
                no-caps
                class="q-px-md"
                unelevated
                label="Download de modelo"
                outline
                color="negative"
                href="https://afilio-v3.s3.us-east-1.amazonaws.com/template_bonus_afiliado.csv"
              />
              <q-btn no-caps class="q-px-md" unelevated label="Fechar" color="primary" v-close-popup />
            </q-card-actions>
          </q-card>
        </q-dialog>

        <div class="q-ma-md q-mb-lg">
          <q-banner class="bg-info text-white q-mb-md" rounded>
            <q-item>
              <q-item-section top avatar>
                <q-icon name="mdi-information-outline" size="lg" />
              </q-item-section>
              <q-item-section>
                <q-item-label class="text-weight-medium">{{ $t("attention_to_file_format") }}</q-item-label>

                <q-item-label caption lines="6" class="text-white"
                  >{{ $t("if_you_have_questions") }} <q-btn dense flat color="white" :label="$t('click_here')" @click="showModal = true" />.
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-banner>

          <q-uploader ref="uploader" flat bordered accept=".csv" class="full-width" @added="getCSV">
            <template v-slot:list="scope">
              <q-list separator>
                <div class="text-center" v-if="scope.files.length == 0">
                  <div class="text-h6 text-primary">{{ $t("drag_and_drop_files") }}</div>
                  <div class="text-caption">{{ $t("or_click_to_select_files") }}</div>
                </div>
                <q-item v-for="file in scope.files" :key="file.name">
                  <q-item-section>
                    <q-item-label class="full-width ellipsis">
                      {{ file.name }}
                    </q-item-label>

                    <q-item-label caption>
                      Status:
                      {{ file.__status }}
                    </q-item-label>

                    <q-item-label caption>
                      {{ file.__sizeLabel }}
                      /
                      {{ file.__progressLabel }}
                    </q-item-label>
                  </q-item-section>

                  <q-item-section v-if="file.__img" thumbnail class="gt-xs">
                    <img :src="file.__img.src" />
                  </q-item-section>

                  <q-item-section top side>
                    <q-btn class="gt-xs" size="12px" flat dense round icon="delete" @click="scope.removeFile(file)" />
                  </q-item-section>
                </q-item>
              </q-list>
            </template>
          </q-uploader>
        </div>

        <q-separator inset />
        <q-card-actions align="right" class="q-pa-md">
          <q-btn outline :label="$t('cancel')" no-caps padding="sm lg" color="primary" @click="onClose" />
          <q-btn unelevated :label="$t('save')" no-caps padding="sm lg" color="primary" type="submit" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import AffiliateMixin from '../../mixins/AffiliateMixin';
import ConversorPhpService from '../../services/ConversorPhpService';

export default {
  name: 'FormUploadAffiliateBonus',
  mixins: [AffiliateMixin, ConversorPhpService],

  data() {
    return {
      showModal: false,
      fileName: '',
      formDataCSV: null
    };
  },

  methods: {
    onClose() {
      this.ActionSetDialogUploadBonusAffiliate(false);
    },

    async onSave() {
      if (!this.$refs.uploader?.files?.length) {
        this.errorNotify(this.$t('select_file_for_upload'));
        return;
      }

      this.onLoading(true);

      try {
        const uploadResponse = await this.uploadFile();
        if (!this.isSuccessStatus(uploadResponse.status)) {
          throw new Error(this.$t('file_upload_failed'));
        }

        const processResponse = await this.processUploadedFile(this.fileName, this.user.email);
        if (!this.isSuccessStatus(processResponse.status)) {
          throw new Error(this.$t('file_processing_failed'));
        }

        this.onClose();
        this.successNotify(this.$t('file_uploaded_processed_successfully'));
      } catch (error) {
        this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    async uploadFile() {
      return await this.$http.post('/v2/upload/file', this.formDataCSV, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    },

    isSuccessStatus(status) {
      return status === 200 || status === 201;
    },

    getCSV(file) {
      let readCsv = new FileReader();
      readCsv.readAsText(file[0]);

      readCsv.onload = () => {
        let csvList = readCsv.result.split('\n');
        let columns = csvList[0].replaceAll('\r', '').split(';');

        const columnLabel = [
          'ID da campanha',
          'ID do canal',
          'Custo',
          'Margem',
          'Data do bonus',
          'Tipo de bonus',
          'Referencia'
        ];
        let fileVerify = false;

        fileVerify = columnLabel.every((el, index) => el === columns[index]);

        if (fileVerify) {
          this.fileName = `bonusBatch_${this.$moment().format('YYYY_MM_DD')}_${this.$moment().format(
            'H_I_S'
          )}_${this.uuidV4()}.csv`;
          this.formDataCSV = new FormData();
          let [fileCSV] = file;
          this.formDataCSV.append('file', fileCSV, this.fileName);
          this.formDataCSV.append('bucket', 's3Bonus');
        } else {
          this.errorNotify(this.$t('incorrect_file_format'));
          this.$refs.uploader.reset();
        }
      };
    }
  }
};
</script>
